/**
 * Utilitários para manipulação de domínios
 */

/**
 * Extrai o domínio principal da URL atual
 * Remove subdomínios como 'www' e retorna apenas o domínio principal
 */
export const extractMainDomain = (hostname: string): string => {
  // Remove 'www.' se presente
  const withoutWww = hostname.replace(/^www\./, '')
  
  // Para desenvolvimento local
  if (withoutWww === 'localhost' || withoutWww.startsWith('127.0.0.1') || withoutWww.includes('.local')) {
    return 'localhost'
  }
  
  // Para domínios de desenvolvimento/staging (como Vercel, Netlify, etc.)
  if (withoutWww.includes('.vercel.app') || withoutWww.includes('.netlify.app') || withoutWww.includes('.bolt.new')) {
    return withoutWww
  }
  
  return withoutWww
}

/**
 * Verifica se o domínio atual é um ambiente de desenvolvimento
 */
export const isDevelopmentDomain = (hostname: string): boolean => {
  return (
    hostname === 'localhost' ||
    hostname.startsWith('127.0.0.1') ||
    hostname.includes('.local') ||
    hostname.includes('.vercel.app') ||
    hostname.includes('.netlify.app') ||
    hostname.includes('.bolt.new')
  )
}

/**
 * Normaliza o domínio para busca no banco de dados
 * Tenta múltiplas variações do domínio
 */
export const normalizeDomainForDatabase = (hostname: string): string[] => {
  const mainDomain = extractMainDomain(hostname)
  
  // Em desenvolvimento, sempre usar 'localhost'
  if (isDevelopmentDomain(mainDomain)) {
    return ['localhost']
  }
  
  // Retorna múltiplas variações do domínio para tentar
  const variations = [
    mainDomain.toLowerCase(),
    `www.${mainDomain.toLowerCase()}`,
    mainDomain.toLowerCase().replace(/^www\./, ''),
  ]
  
  // Remove duplicatas
  return [...new Set(variations)]
}

/**
 * Extrai subdomínio se existir
 */
export const extractSubdomain = (hostname: string): string | null => {
  const parts = hostname.split('.')
  if (parts.length > 2) {
    return parts[0]
  }
  return null
}